<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>

        <h2 *ngIf="form.get('name').value"
            class="headline m-0 flex-auto">{{ form.get('name').value }}</h2>
        <h2 *ngIf="!form.get('name').value"
            class="headline m-0 flex-auto">{{ "GRUPOS.NUEVO" | translate }}</h2>

    </div>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>{{ "GRUPOS.NOMBRE" | translate }}</mat-label>
                <input cdkFocusInitial formControlName="name" matInput>

                <mat-icon class="mr-3" matPrefix svgIcon="mat:person"></mat-icon>
            </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="example-chip-list flex-auto">
                <mat-label>{{ "GRUPOS.USUARIOS" | translate }}</mat-label>
                <mat-chip-list #chipList [placeholder]="'GRUPOS.USUARIOS_SELECCION' | translate">
                    <mat-chip
                        *ngFor="let user of selectedUsers"
                        (removed)="remove(user)">
                        {{user.lastName + ' ' + user.firstName}}
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                    <input
                        [placeholder]="'ACTIONS.BUSCAR_USUARIOS' | translate"
                        #userInput
                        [formControl]="usersCtrl"
                        [matAutocomplete]="auto"
                        [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)"
                                  [displayWith]="displayUserFn">
                    <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
                        {{ user.lastName + ' ' + user.firstName }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-checkbox formControlName="active">{{ "GRUPOS.ACTIVO" | translate }}</mat-checkbox>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">{{ "GRUPOS.CANCELAR" | translate }}</button>
        <button *ngIf="isCreateMode()" color="primary" mat-flat-button
                type="submit">{{ "GRUPOS.CREAR" | translate }}</button>
        <button *ngIf="isUpdateMode()" color="primary" mat-flat-button
                type="submit">{{ "GRUPOS.ACTUALIZAR" | translate }}</button>
    </mat-dialog-actions>
</form>
